// extracted by mini-css-extract-plugin
module.exports = {"regionBadge":"RegionBadge_regionBadge__aIwBz","bundleContainer":"RegionBadge_bundleContainer__u8Fnf"};